const MIN_VISIBLE_MS = 350;

/** Ensures overlay is visible long enough to be perceived (avoids sub-frame flash). */
export async function ensureMinSigningOutVisible(startedAt: number): Promise<void> {
  const elapsed = Date.now() - startedAt;
  if (elapsed < MIN_VISIBLE_MS) {
    await new Promise((resolve) => setTimeout(resolve, MIN_VISIBLE_MS - elapsed));
  }
}
